import React, {type ReactNode} from 'react'
import classNames from '@/Utils/ClassNames'

interface TermsDisclosureProps {
    className?: string
    termsUrl?: string
    privacyUrl?: string
}

export default function TermsDisclosure(
    {
        className = 'mt-2',
        termsUrl = 'https://duesy.me/go/terms',
        privacyUrl = 'https://duesy.me/go/privacy',
    }: TermsDisclosureProps): ReactNode {
    return <div className={classNames('text-xs text-center', className)} data-testid={'terms-disclosure'}>
        By continuing, I accept Duesy&apos;s <a
            target={'_blank'}
            className={'text-royal-10 underline'}
            href={termsUrl}
            rel="noreferrer">Terms<span className={'sr-only'}> (opens in new tab)</span></a> <br/>and acknowledge Duesy&apos;s <a
            target={'_blank'}
            className={'text-royal-10 underline'}
            href={privacyUrl}
            rel="noreferrer">Privacy Policies<span className={'sr-only'}> (opens in new tab)</span></a>.
    </div>
}
